import { Check, Star } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const ProPackageDetailsModal = ({ open, onClose }) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-ink border border-white/10 text-on-dark max-w-2xl max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-sora text-2xl">Mit tartalmaz pontosan?</DialogTitle>
          <DialogDescription className="text-on-dark/60">
            PRO SEO &amp; Lead csomag - 167 000 Ft
          </DialogDescription>
        </DialogHeader>

        {/* Highlighted premium inclusion */}
        <div className="mt-4 p-4 rounded-2xl bg-gradient-to-r from-primary/20 to-accent/20 border border-primary/30">
          <div className="flex items-center gap-2 mb-3">
            <Star size={20} className="text-accent fill-accent" />
            <span className="font-sora font-semibold text-on-dark">Minden ami a Prémium csomagban +</span>
          </div>
          <p className="text-on-dark/70 text-sm">
            A csomag tartalmazza az összes Prémium csomagban található szolgáltatást, plusz az alábbi PRO funkciókat.
          </p>
        </div>

        {/* Premium features summary */}
        <div className="mt-4 p-4 rounded-xl bg-white/5 border border-white/5">
          <p className="text-on-dark/60 text-sm mb-3">Prémium csomag tartalma:</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            <div className="flex items-start gap-2">
              <Check size={14} className="text-accent mt-0.5 flex-shrink-0" />
              <span className="text-on-dark/70 text-xs">Teljes weboldal szövegezés</span>
            </div>
            <div className="flex items-start gap-2">
              <Check size={14} className="text-accent mt-0.5 flex-shrink-0" />
              <span className="text-on-dark/70 text-xs">Konverziós felépítés + GYIK</span>
            </div>
            <div className="flex items-start gap-2">
              <Check size={14} className="text-accent mt-0.5 flex-shrink-0" />
              <span className="text-on-dark/70 text-xs">Szolgáltatás szekció kártyákkal</span>
            </div>
            <div className="flex items-start gap-2">
              <Check size={14} className="text-accent mt-0.5 flex-shrink-0" />
              <span className="text-on-dark/70 text-xs">3 lépéses folyamat blokk</span>
            </div>
            <div className="flex items-start gap-2">
              <Check size={14} className="text-accent mt-0.5 flex-shrink-0" />
              <span className="text-on-dark/70 text-xs">Kattintható CTA-k, sticky mobilon</span>
            </div>
            <div className="flex items-start gap-2">
              <Check size={14} className="text-accent mt-0.5 flex-shrink-0" />
              <span className="text-on-dark/70 text-xs">Google térkép beágyazás</span>
            </div>
            <div className="flex items-start gap-2">
              <Check size={14} className="text-accent mt-0.5 flex-shrink-0" />
              <span className="text-on-dark/70 text-xs">Képgaléria / referencia blokk</span>
            </div>
            <div className="flex items-start gap-2">
              <Check size={14} className="text-accent mt-0.5 flex-shrink-0" />
              <span className="text-on-dark/70 text-xs">YouTube videó beágyazás</span>
            </div>
            <div className="flex items-start gap-2">
              <Check size={14} className="text-accent mt-0.5 flex-shrink-0" />
              <span className="text-on-dark/70 text-xs">Alap analitika mérés</span>
            </div>
            <div className="flex items-start gap-2">
              <Check size={14} className="text-accent mt-0.5 flex-shrink-0" />
              <span className="text-on-dark/70 text-xs">Gyors módosítások átadás után</span>
            </div>
          </div>
        </div>

        {/* PRO features */}
        <div className="space-y-4 mt-6">
          <h4 className="font-sora font-semibold text-lg text-primary">+ PRO funkciók</h4>
          
          {/* SEO Section */}
          <div className="p-4 rounded-xl bg-gradient-to-br from-primary/10 to-transparent border border-primary/20">
            <h5 className="text-on-dark font-semibold mb-3 flex items-center gap-2">
              <Star size={16} className="text-accent" />
              Professzionális SEO csomag (kulcsszó-kutatással)
            </h5>
            <div className="space-y-3 ml-6">
              <div>
                <p className="text-on-dark/90 text-sm font-medium">Kulcsszó-kutatás (10–30 kulcsszó)</p>
                <p className="text-on-dark/60 text-xs mt-0.5">Fő + long-tail + lokális variációk (ha releváns)</p>
              </div>
              <div>
                <p className="text-on-dark/90 text-sm font-medium">Keresési szándék szerinti struktúra finomhangolás</p>
                <p className="text-on-dark/60 text-xs mt-0.5">Mit tegyünk H1/H2-be, milyen alcímek működnek</p>
              </div>
            </div>
          </div>

          {/* Lead Form Section */}
          <div className="p-4 rounded-xl bg-gradient-to-br from-primary/10 to-transparent border border-primary/20">
            <h5 className="text-on-dark font-semibold mb-3 flex items-center gap-2">
              <Star size={16} className="text-accent" />
              Ajánlatkérő / lead űrlap PRO (nem csak &quot;kapcsolat&quot;)
            </h5>
            <div className="space-y-3 ml-6">
              <div>
                <p className="text-on-dark/90 text-sm font-medium">Több mezős ajánlatkérő űrlap</p>
                <p className="text-on-dark/60 text-xs mt-0.5">Szolgáltatás választó, sürgősség, helyszín, időpont preferencia, stb.</p>
              </div>
              <div>
                <p className="text-on-dark/90 text-sm font-medium">Validáció + hibakezelés + visszajelző állapotok</p>
                <p className="text-on-dark/60 text-xs mt-0.5">Professzionális felhasználói élmény</p>
              </div>
            </div>
          </div>

          {/* Social Media Section */}
          <div className="p-4 rounded-xl bg-gradient-to-br from-primary/10 to-transparent border border-primary/20">
            <h5 className="text-on-dark font-semibold mb-3 flex items-center gap-2">
              <Star size={16} className="text-accent" />
              Social media csomag: Facebook / Google / Tiktok pixel + konverziókövetés
            </h5>
            <div className="ml-6">
              <p className="text-on-dark/90 text-sm font-medium">Pixel elhelyezés és konverziókövetés</p>
              <p className="text-on-dark/60 text-xs mt-0.5">Segít abban, hogy pontosan lásd, melyik hirdetés hoz valódi érdeklődőket (űrlap, hívás, kattintás), ne csak látogatókat. Így a kampányok mérhetővé és optimalizálhatóvá válnak: kevesebb felesleges költés, több olyan megkeresés, ami tényleg ügyfél lehet.</p>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ProPackageDetailsModal;
